import React, { useState, useEffect } from 'react';
import emailjs from '@emailjs/browser';
import '../styles/Contact.css';

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    service: '',
    message: ''
  });

  const [formStatus, setFormStatus] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Inicializar EmailJS
  useEffect(() => {
    emailjs.init('rf-LnCWPtf-K-Y83d');
    console.log('✅ EmailJS inicializado para Marcus Security');
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    console.log('🚀 Enviando solicitud...');
    
    // Preparar parámetros para EmailJS
    const templateParams = {
      from_name: formData.name,
      from_email: formData.email,
      from_phone: formData.phone,
      company: formData.company || 'No especificada',
      service: formData.service,
      message: formData.message
    };

    console.log('📧 Datos a enviar:', templateParams);

    // Enviar email con EmailJS
    emailjs.send(
      'service_a4p40uk',
      'template_5y3tv0h',
      templateParams
    )
    .then((response) => {
      console.log('✅ Email enviado exitosamente:', response.status, response.text);
      setFormStatus('success');
      setIsSubmitting(false);
      
      // Limpiar formulario después de 3 segundos
      setTimeout(() => {
        setFormData({
          name: '',
          email: '',
          phone: '',
          company: '',
          service: '',
          message: ''
        });
        setFormStatus('');
      }, 3000);
    })
    .catch((error) => {
      console.error('❌ Error al enviar email:', error);
      setFormStatus('error');
      setIsSubmitting(false);
      
      // Ocultar mensaje de error después de 5 segundos
      setTimeout(() => {
        setFormStatus('');
      }, 5000);
    });
  };

  return (
    <div className="contact-page">
      {/* Hero Section */}
      <section 
        className="page-hero"
        style={{
          backgroundImage: 'linear-gradient(135deg, rgba(26, 26, 26, 0.3) 0%, rgba(13, 13, 13, 0.4) 100%), url(/images/contact-hero-bg.png)',
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <div className="hero-overlay"></div>
        <div className="container">
          <h1>Contáctanos</h1>
          <p>Estamos aquí para proteger lo que más valoras</p>
        </div>
      </section>

      {/* Contact Content */}
      <section className="contact-content">
        <div className="container">
          <div className="contact-grid">
            {/* Contact Form */}
            <div className="contact-form-section">
              <div className="form-header">
                <span className="section-tag">Solicita tu Cotización</span>
                <h2>¿Cómo Podemos Ayudarte?</h2>
                <p className="form-intro">Completa el formulario y nos pondremos en contacto contigo en menos de 24 horas.</p>
              </div>

              <form onSubmit={handleSubmit} className="contact-form">
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="name">
                      <span className="label-icon">👤</span>
                      Nombre Completo *
                    </label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      placeholder="Juan Pérez González"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="email">
                      <span className="label-icon">✉️</span>
                      Email *
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      placeholder="juan.perez@empresa.cl"
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="phone">
                      <span className="label-icon">📱</span>
                      Teléfono *
                    </label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      required
                      placeholder="+56 9 1234 5678"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="company">
                      <span className="label-icon">🏢</span>
                      Empresa
                    </label>
                    <input
                      type="text"
                      id="company"
                      name="company"
                      value={formData.company}
                      onChange={handleChange}
                      placeholder="Nombre de tu empresa"
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="service">
                    <span className="label-icon">🛡️</span>
                    Servicio de Interés *
                  </label>
                  <select
                    id="service"
                    name="service"
                    value={formData.service}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Selecciona un servicio</option>
                    <option value="Recursos Humanos / Guardias de Seguridad">Recursos Humanos / Guardias de Seguridad</option>
                    <option value="Gestión de Riesgos Operacionales">Gestión de Riesgos Operacionales</option>
                    <option value="Auditorías">Auditorías</option>
                    <option value="Investigación y Prevención de Fraudes">Investigación y Prevención de Fraudes</option>
                    <option value="Prevención de Pérdidas">Prevención de Pérdidas</option>
                    <option value="Asesorías en Seguridad">Asesorías en Seguridad</option>
                    <option value="Tecnología y Proyectos">Tecnología y Proyectos</option>
                    <option value="Otro">Otro</option>
                  </select>
                </div>

                <div className="form-group">
                  <label htmlFor="message">
                    <span className="label-icon">💬</span>
                    Mensaje *
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    rows="5"
                    placeholder="Cuéntanos sobre tus necesidades de seguridad, ubicación del servicio, horarios requeridos, número de guardias, etc."
                  ></textarea>
                </div>

                <button 
                  type="submit" 
                  className={`btn btn-primary btn-submit ${isSubmitting ? 'loading' : ''}`}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? 'Enviando...' : 'Enviar Solicitud'}
                </button>

                {formStatus === 'success' && (
                  <div className="form-status success">
                    <span className="status-icon">✓</span>
                    ¡Gracias por contactarnos! Nos pondremos en contacto contigo pronto.
                  </div>
                )}

                {formStatus === 'error' && (
                  <div className="form-status error">
                    <span className="status-icon">✗</span>
                    Error al enviar. Por favor, intenta de nuevo o llámanos al +56 9 7791 1221
                  </div>
                )}
              </form>
            </div>

            {/* Contact Info */}
            <div className="contact-info-section">
              <div className="contact-info-card">
                <h3>Información de Contacto</h3>
                
                <div className="info-item">
                  <div className="info-icon-wrapper">
                    <img src="/images/icons/phone-icon.png" alt="Teléfono" />
                  </div>
                  <div className="info-content">
                    <h4>Teléfono</h4>
                    <a href="tel:+56977911221">+56 9 7791 1221</a>
                    <p className="info-note">Lunes a Viernes: 9:00 - 18:00 hrs</p>
                  </div>
                </div>

                <div className="info-item">
                  <div className="info-icon-wrapper">
                    <img src="/images/icons/email-icon.png" alt="Email" />
                  </div>
                  <div className="info-content">
                    <h4>Email Principal</h4>
                    <a href="mailto:asalinas@marcussecurity.cl">asalinas@marcussecurity.cl</a>
                    <p className="info-note">Respuesta en menos de 24 horas</p>
                  </div>
                </div>

                <div className="info-item">
                  <div className="info-icon-wrapper">
                    <img src="/images/icons/location-icon.png" alt="Ubicación" />
                  </div>
                  <div className="info-content">
                    <h4>Dirección</h4>
                    <p>Limache 3421, Oficina 723</p>
                    <p>Viña del Mar</p>
                    <p>Región de Valparaíso, Chile</p>
                  </div>
                </div>

                <div className="info-item">
                  <div className="info-icon-wrapper">
                    <img src="/images/icons/business-icon.png" alt="RUT" />
                  </div>
                  <div className="info-content">
                    <h4>Información Legal</h4>
                    <p><strong>RUT:</strong> 76.261.664-5</p>
                    <p><strong>Razón Social:</strong> Salinas y Bensa Seguridad Privada SPA</p>
                    <p><strong>Autorización OS10:</strong> 0805XXXXXXXX</p>
                  </div>
                </div>
              </div>

              <div className="contact-team-card">
                <h3>Contacta Directamente</h3>
                
                <div className="team-contact">
                  <div className="team-avatar">CS</div>
                  <div className="team-info">
                    <h4>Constanza Sepúlveda</h4>
                    <p className="team-role">Gerente General</p>
                    <a href="mailto:csepulveda@marcussecurity.cl">csepulveda@marcussecurity.cl</a>
                  </div>
                </div>

                <div className="team-contact">
                  <div className="team-avatar">AS</div>
                  <div className="team-info">
                    <h4>Alejandro Salinas</h4>
                    <p className="team-role">Asesor de Seguridad</p>
                    <a href="mailto:asalinas@marcussecurity.cl">asalinas@marcussecurity.cl</a>
                  </div>
                </div>

                <div className="team-contact">
                  <div className="team-avatar">RB</div>
                  <div className="team-info">
                    <h4>Rossana Bensa</h4>
                    <p className="team-role">Gerente Comercial</p>
                    <a href="mailto:rbensa@marcussecurity.cl">rbensa@marcussecurity.cl</a>
                  </div>
                </div>
              </div>

             
            </div>
          </div>
        </div>
      </section>

      {/* Coverage Section */}
      <section className="coverage-section">
        <div className="container">
          <div className="section-header">
            <span className="section-tag">Cobertura Regional</span>
            <h2>¿Dónde Operamos?</h2>
          </div>
          
          <div className="coverage-grid">
            <div className="coverage-card">
              <div className="region-number">01</div>
              <h3>Región Metropolitana</h3>
              <p>Santiago y todas sus comunas</p>
              <div className="card-accent"></div>
            </div>

            <div className="coverage-card">
              <div className="region-number">02</div>
              <h3>Región de Valparaíso</h3>
              <p>Viña del Mar, Valparaíso y zona costera</p>
              <div className="card-accent"></div>
            </div>

            <div className="coverage-card">
              <div className="region-number">03</div>
              <h3>Región de Antofagasta</h3>
              <p>Antofagasta y zona norte</p>
              <div className="card-accent"></div>
            </div>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="map-section">
        <div className="container">
          <h2>Nuestra Ubicación Principal</h2>
          <div className="map-container">
            <iframe
              title="Ubicación Marcus Security - Viña del Mar"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3344.1234567890!2d-71.5519!3d-33.0247!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzPCsDAxJzI5LjAiUyA3McKwMzMnMDYuOCJX!5e0!3m2!1ses!2scl!4v1234567890"
              width="100%"
              height="450"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
          <div className="map-info">
            <div className="map-info-item">
              <strong>📍 Dirección:</strong> Limache 3421, Oficina 723, Viña del Mar
            </div>
            <div className="map-info-item">
              <strong>🚗 Cómo llegar:</strong> Fácil acceso desde ruta principal, estacionamiento disponible
            </div>
            <div className="map-info-item">
              <strong>🚌 Transporte público:</strong> Múltiples líneas de buses cercanas
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="faq-section">
        <div className="container">
          <div className="section-header">
            <span className="section-tag">Preguntas Frecuentes</span>
            <h2>¿Tienes Dudas?</h2>
          </div>
          
          <div className="faq-grid">
            <div className="faq-item">
              <div className="faq-question">
                <span className="faq-icon">❓</span>
                <h4>¿En cuánto tiempo responden a una cotización?</h4>
              </div>
              <p>Respondemos todas las solicitudes en un plazo máximo de 24 horas hábiles. Para casos urgentes, puedes llamarnos directamente al +56 9 7791 1221.</p>
            </div>

            <div className="faq-item">
              <div className="faq-question">
                <span className="faq-icon">❓</span>
                <h4>¿Los guardias están certificados?</h4>
              </div>
              <p>Sí, todo nuestro personal está registrado y autorizado por Carabineros de Chile (OS10) bajo el número 0805XXXXXXXX, con capacitación continua y seguros de responsabilidad civil.</p>
            </div>

            <div className="faq-item">
              <div className="faq-question">
                <span className="faq-icon">❓</span>
                <h4>¿Qué zonas geográficas cubren?</h4>
              </div>
              <p>Operamos en las Regiones Metropolitana, de Valparaíso y de Antofagasta con personal capacitado en cada zona.</p>
            </div>

            <div className="faq-item">
              <div className="faq-question">
                <span className="faq-icon">❓</span>
                <h4>¿Trabajan con contratos a corto plazo?</h4>
              </div>
              <p>Sí, ofrecemos tanto guardias permanentes como esporádicos. Podemos adaptarnos a eventos puntuales, refuerzos temporales o servicios permanentes.</p>
            </div>

            <div className="faq-item">
              <div className="faq-question">
                <span className="faq-icon">❓</span>
                <h4>¿Ofrecen servicios las 24 horas?</h4>
              </div>
              <p>Sí, proporcionamos servicios de vigilancia 24/7 los 365 días del año, adaptándonos completamente a tu horario operativo.</p>
            </div>

            <div className="faq-item">
              <div className="faq-question">
                <span className="faq-icon">❓</span>
                <h4>¿Qué seguros tienen?</h4>
              </div>
              <p>Contamos con seguro de responsabilidad civil hasta 1.000 UF (HDI Seguros), seguro de vida para todos los guardias y afiliación a ACHS para accidentes laborales.</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="contact-cta">
        <div className="container">
          <div className="cta-content">
            <h2>¿Listo para Proteger tu Negocio?</h2>
            <p>Contáctanos hoy y recibe una evaluación gratuita de tus necesidades de seguridad</p>
            <div className="cta-buttons">
              <a href="tel:+56977911221" className="btn btn-primary">
                <span className="btn-icon">📞</span>
                Llamar Ahora
              </a>
              <a href="mailto:asalinas@marcussecurity.cl" className="btn btn-secondary">
                <span className="btn-icon">✉️</span>
                Enviar Email
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Contact;